var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page__404"},[_c('img',{attrs:{"src":"//cdn.yxvzb.com/WEB/SaaS/pc/images/404.png"}})])}]

export { render, staticRenderFns }